import React, { useState, useEffect, useMemo } from "react";
import Gallery from "react-bnb-gallery";
import { useTranslation } from "react-i18next";
import { slimImage } from "@/service/utils";

const Template = (props) => {
  return props.show ? <React.Fragment>{props.children}</React.Fragment> : null;
};

/**详情 */
export const Details = ({ restaurant, tags }) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false)
  let {
    basic_info,
    book_config,
    location,
    landmarks = [],
    cuisines = [],
    tags: restaurantTags = [],
    licenses
  } = restaurant;
  basic_info = basic_info || {};
  location = location || {};
  
  licenses = licenses.map(item => item.picture_url)

  const policy = useMemo(() => {
    try {
      return book_config.cancel.policy;
    } catch (error) {
      return ''
    }
  })
  return (
    <section className="page-restaurant--details">
      <h3>{t("WEB.Details")}</h3>
      <Tags tags={tags} />
      {/* 餐厅其他信息 */}
      <div className="page-restaurant--others">
        <h4>{t("WEB.Introduction")}</h4>
        <div
          className="restaurant-description"
          dangerouslySetInnerHTML={{
            __html: basic_info.description,
          }}
        ></div>
        <Template show={policy}>
          <h4>{t("WEB.Cancellation policy")}</h4>
          <div
            className="restaurant-cancellation"
            dangerouslySetInnerHTML={{
              __html: policy,
            }}
          ></div>
        </Template>
        <Template show={location.name}>
          <h4>{t("WEB.District")}</h4>
          <div className="restaurant-tags">
            <div className="tag-button">{location.name}</div>
          </div>
        </Template>
        <h4>{t("WEB.Landmarks")}</h4>
        <div className="restaurant-tags">
          {landmarks.map((item) => {
            return (
              <div className="tag-button" key={item.id}>
                {item.name}
              </div>
            );
          })}
        </div>
        <h4>{t("WEB.Cuisines")}</h4>
        <div className="restaurant-tags">
          {cuisines.map((item) => {
            return (
              <div className="tag-button" key={item.id}>
                {item.name}
              </div>
            );
          })}
        </div>
        <h4>{t("WEB.Tags")}</h4>
        <div className="restaurant-tags">
          {restaurantTags.map((item) => {
            return (
              <div className="tag-button" key={item.id}>
                {item.name}
              </div>
            );
          })}
        </div>
        {
          !!licenses.length && (
            <React.Fragment>
              <h4>{t("WEB.Licenses")}</h4>
              <div className="restaurant-tags">
                {licenses.map((item, index) => {
                  let photo = `${item}?imageView2/1/w/24/h/24/interlace/1`.replace('??', '?')
                  return (
                    <div className="license-button" key={index} onClick={() => setShow(true)}>
                      <img src={photo} alt="" />
                      <i className="icon icon-eye"></i>
                    </div>
                  );
                })}
              </div>
            </React.Fragment>
          )
        }
      </div>
      <Gallery
        onClose={() => setShow(false)}
        photos={licenses}
        show={show}
        showThumbnails={false}
      ></Gallery>
    </section>
  );
};

/* 餐厅标签 */
const Tags = ({ tags }) => {
  return (
    <div className="page-restaurant--tags">
      {tags.map((item, index) => {
        return (
          <div className="tag-item" key={index}>
            <img
              className="tag-icon"
              src={slimImage(item.icon_url, "/w/64/h/64")}
            />
            <div className="tag-content">
              <div className="tag-name">{item.name}</div>
              <div
                className="tag-description"
                dangerouslySetInnerHTML={{
                  __html: item.description,
                }}
              ></div>
              <div className="tag-link">{item.link.text}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
